import React from 'react';
import { string, bool, arrayOf, func, object } from 'prop-types';
import { propTypes } from '../../../util/types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { ListingCard, NamedLink, IconArrow } from '../../../components';

import css from './SectionListingsOrdered.module.css';

const MINIMUM_LISTING_COUNT = 0;

const sortByHomepageOrderThenNew = listings =>
  (Array.isArray(listings) ? listings : [])
    .slice()
    .sort((a, b) => {
      const aOrder = a.attributes?.homepageOrder;
      const bOrder = b.attributes?.homepageOrder;

      if (aOrder != null && bOrder != null) {
        return bOrder - aOrder;
      }
      if (aOrder != null) return -1;
      if (bOrder != null) return 1;

      return (
        new Date(b.attributes?.createdAt) -
        new Date(a.attributes?.createdAt)
      );
    });


const SectionListingsOrdered = props => {
  const {
    rootClassName,
    className,
    listings,
    queryListingsInProgress,
    queryListingsError,
    title,
    filterFn,
    exploreSearch,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  if (queryListingsInProgress || queryListingsError) {
    return null;
  }



  const safeListings = Array.isArray(listings) ? listings : [];

  const filteredListings = filterFn
    ? filterFn(safeListings)
    : safeListings;

  const orderedListings = sortByHomepageOrderThenNew(
  Array.isArray(filteredListings) ? filteredListings : []
);


    

  const hasListings = orderedListings.length > MINIMUM_LISTING_COUNT;

  if (!hasListings) {
    return null;
  }

  return (
    <div className={classes}>
      <div className={css.header}>
        <div className={css.title}>
          {title || 'Shop New Products'}
        </div>

        <NamedLink
          className={css.exploreLink}
          name="SearchPage"
          {...(exploreSearch ? { to: exploreSearch } : {})}
        >
          <FormattedMessage id="SectionListings.explore" />
          <IconArrow className={css.exploreIcon} />
        </NamedLink>
      </div>

      <div className={css.listingCards}>
        {orderedListings.map(l => (
          <ListingCard
            key={l.id.uuid}
            listing={l}
            showAuthorInfo
            className={css.listingCard}
          />
        ))}
      </div>
    </div>
  );
};

SectionListingsOrdered.defaultProps = {
  rootClassName: null,
  className: null,
  queryListingsInProgress: false,
  queryListingsError: null,
  title: null,
  filterFn: null,
  exploreSearch: null,
};

SectionListingsOrdered.propTypes = {
  rootClassName: string,
  className: string,
  listings: arrayOf(propTypes.listing),
  queryListingsInProgress: bool.isRequired,
  queryListingsError: propTypes.error,
  title: string,
  filterFn: func,
  exploreSearch: object,
};

export default SectionListingsOrdered;
